import { useState } from 'react';
import { store } from '../redux/store';
import { removeToken, removeUser } from '../redux/auth/auth.action';
import { removeActiveTab } from '../redux/active-tabs/active-tab.action';

export function useDebounce(func, delay) {
  const [timer, setTimer] = useState(null);
  return (...args) => {
    clearTimeout(timer);
    let _temp = setTimeout(() => {
      func(...args);
    }, delay);
    setTimer(_temp);
  };
}

export const logout = async () => {
  await store.dispatch(removeToken());
  await store.dispatch(removeUser());
  await store.dispatch(removeActiveTab());
};

export const convertArrayToObject = (data, key) => {
  if (!key) {
    return {};
  }

  return data.reduce((result, item) => {
    const keyValue = item[key];

    if (typeof keyValue === 'string') {
      return { ...result, [keyValue]: { ...item } };
    }

    return result;
  }, {});
};
